import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d545a40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex items-center bg-background-medium w-min" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "p-2 text-text-black" }, "...", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_icon = _resolveComponent("base-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToHomePage && _ctx.goToHomePage(...args)))
      }, [
        _createVNode(_component_base_icon, {
          icon: "home",
          class: "p-2 purple cursor-pointer align-center"
        })
      ]),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToHistoryPage('backward')))
      }, [
        _createVNode(_component_base_icon, {
          icon: "arrowLeft",
          class: _normalizeClass(_ctx.currentPageIndex - 1 != -1 ? 'p-2 purple cursor-pointer' : 'p-2 gray cursor-not-allowed blur-lg')
        }, null, 8, ["class"])
      ]),
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateToHistoryPage('forward')))
      }, [
        _createVNode(_component_base_icon, {
          icon: "arrowRight",
          class: _normalizeClass(_ctx.currentPageIndex < _ctx.history.length - 1 ? 'p-2 purple cursor-pointer' : 'p-2 gray cursor-not-allowed')
        }, null, 8, ["class"])
      ])
    ]),
    _createElementVNode("section", _hoisted_3, [
      (_ctx.history.length >= 10)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history.slice(_ctx.currentPageIndex - 10), (page, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex items-center cursor-pointer"
        }, [
          _createVNode(_component_base_icon, {
            icon: "arrowRightLine",
            class: "p-2 black"
          }),
          _createElementVNode("h4", {
            class: _normalizeClass(page.active ? 'text-text-black' : 'text-accent-purple'),
            onClick: ($event: any) => (_ctx.navigateToPageByUrl(page))
          }, _toDisplayString(page.name), 11, _hoisted_7)
        ]))
      }), 128))
    ])
  ]))
}